import QuestionselectrangeModule from './containers/questionselectrangeModule'

export {default as QuestionselectrangeModuleLayout} from './components/questionselectrangeModuleLayout'

export default QuestionselectrangeModule
